export default __webpack_public_path__ + "static/media/transport-logistics-compressed.7a9b114a.jpg";